import {
  getServerLocale,
  initServerTranslation,
} from '@bts-web/utils-lokalise';
import {
  getTradeTranslations,
  TradeScreenTranslations,
} from '../utils/getTradeTranslations';
import { NavigationBackButton } from '../../navigation/index';
import { NavigationBar } from '../../common';
import { TFunction } from 'i18next';
import { PreAcceptSavingsPlanMutation$data } from '@bts-web/data-layer/server';
import { AcceptSavingsPlan } from './AcceptSavingsPlan';
import { CancelTradeWithConfirmButton } from '../Reusable/CancelTradeConfirmationModal/CancelTradeWithConfirmButton';

export type AcceptSavingsPlanControllerProps = {
  savingsPlanData: NonNullable<
    PreAcceptSavingsPlanMutation$data['preAcceptSavingsPlan']
  >;
};

const AcceptSavingsPlanController = async ({
  savingsPlanData,
}: AcceptSavingsPlanControllerProps) => {
  const { t } = await initServerTranslation();

  const currentLocale = await getServerLocale();

  const translations = getTradeTranslations(t as TFunction);

  return (
    <>
      <NavigationBar
        title={translations.savingsPlan}
        NavigationLeftSlot={<NavigationBackButton />}
        NavigationRightSlot={
          <CancelTradeWithConfirmButton translations={translations} />
        }
      />
      <AcceptSavingsPlan
        currentLocale={currentLocale}
        savingsPlanData={savingsPlanData}
        translations={translations as TradeScreenTranslations}
      />
    </>
  );
};

export { AcceptSavingsPlanController };
